import React, { useState } from 'react';
import { Copy, Check, FacebookLogo, WhatsappLogo, MapPin, Wrench, Clock, ShareNetwork } from '@phosphor-icons/react';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PostPreview({ post }) {
  const [copied, setCopied] = useState(false);
  const [publishing, setPublishing] = useState(false);

  if (!post) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(post.content);
      setCopied(true);
      toast.success('Post copié dans le presse-papiers !');
      setTimeout(() => setCopied(false), 2000);
    } catch { toast.error('Impossible de copier'); }
  };

  const handlePublishToGallery = async () => {
    setPublishing(true);
    try {
      await axios.post(`${API}/posts/${post.id}/publish`, {}, { withCredentials: true });
      toast.success('Post publié dans la galerie !');
    } catch (err) {
      const msg = err.response?.data?.detail;
      toast.error(typeof msg === 'string' ? msg : 'Erreur de publication');
    } finally { setPublishing(false); }
  };

  const formatDate = (dateStr) => {
    try { return new Date(dateStr).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }); }
    catch { return dateStr; }
  };

  return (
    <div className="animate-slide-in-right bg-[#18181B] border border-[#27272A] rounded-lg overflow-hidden" data-testid="post-preview">
      <div className="px-4 py-3 border-b border-[#27272A] flex items-center justify-between">
        <div className="flex items-center gap-3 flex-wrap">
          <div className="flex items-center gap-1.5 text-xs text-[#A1A1AA]">
            {post.platform === 'facebook' ? <FacebookLogo size={16} weight="duotone" className="text-blue-400" /> : <WhatsappLogo size={16} weight="duotone" className="text-green-400" />}
            <span className="font-medium capitalize">{post.platform}</span>
          </div>
          <span className="text-[#3F3F46]">|</span>
          <div className="flex items-center gap-1 text-xs text-[#A1A1AA]"><MapPin size={14} weight="duotone" />{post.city}</div>
          <span className="text-[#3F3F46]">|</span>
          <div className="flex items-center gap-1 text-xs text-[#A1A1AA]"><Wrench size={14} weight="duotone" />{post.construction_type}</div>
        </div>
        <div className="flex items-center gap-1 text-xs text-[#71717A]"><Clock size={14} weight="duotone" />{formatDate(post.created_at)}</div>
      </div>
      <div className="p-5">
        <div className="whitespace-pre-wrap text-base leading-relaxed text-[#E4E4E7]" data-testid="post-content">{post.content}</div>
      </div>
      <div className="px-4 py-3 border-t border-[#27272A] flex items-center justify-end gap-2">
        <button onClick={handlePublishToGallery} disabled={publishing || post.published_to_gallery} data-testid="publish-gallery-button"
          className="h-10 px-4 rounded-lg font-medium text-sm flex items-center gap-2 transition-all bg-[#27272A] text-[#A1A1AA] hover:bg-[#3F3F46] hover:text-[#F4F4F5] disabled:opacity-40">
          <ShareNetwork size={16} weight="duotone" /> {post.published_to_gallery ? 'Publié' : 'Publier en galerie'}
        </button>
        <button onClick={handleCopy} data-testid="copy-post-button"
          className={`h-10 px-5 rounded-lg font-semibold text-sm flex items-center gap-2 transition-all ${copied ? 'bg-green-500/15 text-green-400 border border-green-500/30' : 'bg-[#8B5CF6] text-white hover:bg-[#7C3AED]'}`}>
          {copied ? <><Check size={18} weight="bold" /> Copié !</> : <><Copy size={18} weight="duotone" /> Copier le post</>}
        </button>
      </div>
    </div>
  );
}
